import React, { useState, useEffect } from 'react';
import type { User } from '../../types';

interface AvatarProps {
  user: User | null;
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({ user, className = 'h-9 w-9' }) => {
  const [imageError, setImageError] = useState(false);

  // Reset error state when user/avatar changes
  useEffect(() => {
    setImageError(false);
  }, [user?.avatarUrl]);

  if (!user) {
    return (
      <div className={`${className} rounded-full bg-gray-200 dark:bg-gray-700`}></div>
    );
  }

  if (user.avatarUrl && !imageError) {
    return (
      <img
        className={`${className} rounded-full object-cover`}
        src={user.avatarUrl}
        alt={`${user.prénom} ${user.nom}`}
        crossOrigin="anonymous"
        onError={() => setImageError(true)}
      />
    );
  }

  return (
    <div className={`${className} flex items-center justify-center rounded-full bg-primary-100 dark:bg-primary-800 text-primary-600 dark:text-primary-300 font-bold text-sm border border-primary-200 dark:border-primary-700`}>
      {user.prénom?.charAt(0).toUpperCase()}{user.nom?.charAt(0).toUpperCase()}
    </div>
  );
};

export default Avatar;